'use strict';

var $ = require('jquery');
var Magnific = require('magnific-popup');
var VideoResource = require('./VideoResource.js');

function initVideoResources() {
    var videoResources = document.querySelectorAll('.videoResource');

    if (!videoResources.length) return;

    var videoLightBoxes = [];
    for (var i = 0; i < videoResources.length; i++) {
        /* var headingEl = videoResources[i].querySelector('.listItem__heading');
        var heading = headingEl ? headingEl.textContent : '';
        
        var subheadingEl = videoResources[i].querySelector('.listItem__subheading');
        var subheading = subheadingEl ? subheadingEl.textContent : '';

        var captionEl = videoResources[i].querySelector('.resourceCaption');
        var caption = captionEl ? captionEl.getAttribute('data-caption') : ''; */

        var anchors = videoResources[i].querySelectorAll('a');

        /* videoLightBoxes.push(
            new VideoResource(
                videoResources[i],
                heading,
                subheading,
                caption,
                anchors
            )
        ); */
        videoLightBoxes.push(
            new VideoResource(
                videoResources[i],
                anchors
            )
        );
    }

    for (var i = 0; i < videoLightBoxes.length; i++) {
        $(videoLightBoxes[i].anchors).magnificPopup({
            type: 'iframe',
            iframe: {
                markup: videoLightBoxes[i].markup
            }
        });
    }
}

module.exports = {
    init: initVideoResources
}
